import { useNavigate } from "react-router-dom";
import styles from "./ads.module.scss";
import { _adr } from "../../address";
import { Button, Image } from "antd";
import { useState } from "react";
const ADS = () => {
  const nav = useNavigate();
  const [visible, setVisible] = useState(false);
  return (
    <>
      <div className={styles.holder_banner_ads}>
        <ul>
          <li style={{ cursor: "pointer" }} onClick={() => setVisible(true)}>
            <img src={process.env.PUBLIC_URL + process.env.REACT_APP_ROOT_PATH_FILE + "/assets/images/Infographic-Banner.jpg"} alt="" />
          </li>
          <li style={{ cursor: "pointer" }} onClick={(e) => (window.location.href = "https://simcardstore.aptel.ir/html/bundle-simcard.html")}>
            <img src={process.env.PUBLIC_URL + process.env.REACT_APP_ROOT_PATH_FILE + "/assets/images/banner-02.jpg"} alt="" />
          </li>
          <li style={{ cursor: "pointer" }} onClick={(e) => (window.location.href = "https://simcardstore.aptel.ir/html/bundle-simcard.html")}>
            <img src={process.env.PUBLIC_URL + process.env.REACT_APP_ROOT_PATH_FILE + "/assets/images/Number8-Banner-Auction-Internal.gif"} alt="" />
          </li>
        </ul>
      </div>
      <Image
        width={200}
        style={{
          display: "none",
        }}
        src={process.env.PUBLIC_URL + process.env.REACT_APP_ROOT_PATH_FILE + "/assets/images/Infographic 02-01.jpg"}
        preview={{
          visible,
          src: process.env.PUBLIC_URL + process.env.REACT_APP_ROOT_PATH_FILE + "/assets/images/Infographic 02-01.jpg",
          onVisibleChange: (value) => {
            setVisible(value);
          },
        }}
      />
    </>
  );
};

export default ADS;
